<template>
    <div :class="classes">
        <slot></slot>
    </div>
</template>

<script>
import './container.scss';

export default {
    name: 'Container',
    __editor: {
        fields: {
            type: {
                widget: 'select',
                values: ['column', 'row'],
            },
            spacing: {
                widget: 'select',
                values: ['default', 'space-between', 'space-around', 'space-evenly', 'center', 'end', 'start'],
            },
            alignment: {
                widget: 'select',
                values: ['default', 'stretch', 'center', 'end', 'start'],
            },
            backgroundColor: {
                widget: 'select',
                values: ['none', 'white', 'grey', 'primary', 'secondary'],
            },
            horizontalPadding: {
                widget: 'select',
                values: ['none', 'small', 'medium', 'large', 'xlarge', 'xxlarge'],
            },
            verticalPadding: {
                widget: 'select',
                values: ['none', 'small', 'medium', 'large', 'xlarge', 'xxlarge'],
            },
        },
    },
    props: {
        lg: {
            type: Number,
        },
        sm: {
            type: Number,
        },
        type: {
            type: String,
            default: 'column',
        },
        spacing: {
            type: String,
            default: 'default',
            validator: function(val) {
                return ['default', 'space-between', 'space-around', 'space-evenly', 'center', 'end', 'start'].includes(
                    val
                );
            },
        },
        alignment: {
            type: String,
            default: 'default',
            validator: function(val) {
                return ['default', 'stretch', 'center', 'end', 'start'].includes(val);
            },
        },
        backgroundColor: {
            type: String,
            required: false,
            default: 'none',
        },
        horizontalPadding: {
            type: String,
            default: 'none',
        },
        verticalPadding: {
            type: String,
            default: 'none',
        },
        reverseOrderMobile: {
            type: Boolean,
            default: false,
        },
        noPadding: {
            type: Boolean,
            default: false,
        },
        noHorizontalMargin: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        classes() {
            let classes = [
                'scc-container',
                `scc-container--spacing-${this.spacing}`,
                `scc-container--alignment-${this.alignment}`,
                { 'scc-container--row': this.type === 'row' },
            ];
            if (this.backgroundColor !== 'none') classes.push(`scc-container--${this.backgroundColor}`);
            if (this.verticalPadding !== 'none')
                classes.push(`scc-container--vertical-padding-${this.verticalPadding}`);
            if (this.horizontalPadding !== 'none')
                classes.push(`scc-container--horizontal-padding-${this.horizontalPadding}`);
            if (this.reverseOrderMobile) classes.push('scc-container--reverse-order-mobile');
            if (this.sm) classes.push(`scc-container__column scc-container__sm-column--${this.sm}`);
            if (this.lg) classes.push(`scc-container__column scc-container__lg-column--${this.lg}`);
            if (this.noPadding) classes.push('scc-container--no-padding');
            if (this.noHorizontalMargin) classes.push('scc-container--no-horizontal-margin');

            return classes;
        },
    },
};
</script>
